<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {}
    },
    computed: {},
    methods: {

    },
    components: {},
    mounted() {

    },

    created() {

    },
  }
</script>

<style>
  @import '../static/styles/beas.css';
  @import '../static/styles/all.css';
  @import '../static/styles/all.css';
</style>



// WEBPACK FOOTER //
// src/App.vue